import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import { MINT_MIST } from '../../constants/brandSurfaces';

export const Band = styled('section')({
  display: 'flex',
  alignItems: 'center',
  gap: 20,
  margin: '20px 0 48px',
  padding: '28px 36px',
  borderRadius: 24,
  color: '#1a1a2e',
  background: MINT_MIST,
  border: '1px solid rgba(26, 26, 46, 0.06)',
  '@media (max-width: 760px)': {
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 14,
    padding: '26px 22px',
  },
  '@media (max-width: 600px)': {
    margin: '16px 0 32px',
    borderRadius: 16,
  },
});

export const BandIcon = styled('span')({
  flex: '0 0 auto',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 52,
  height: 52,
  borderRadius: 14,
  color: '#0d4efe',
  background: '#ffffff',
  boxShadow: '0 4px 14px rgba(13, 78, 254, 0.12)',
  '& svg': { fontSize: 28 },
});

export const BandCopy = styled('div')({
  flex: '1 1 auto',
  textAlign: 'left',
});

export const BandTitle = styled('h2')({
  fontFamily: "'Plus Jakarta Sans', sans-serif",
  fontSize: '1.3rem',
  fontWeight: 800,
  letterSpacing: '-0.01em',
  lineHeight: 1.3,
  margin: '0 0 4px',
  color: '#1a1a2e',
});

export const BandText = styled('p')({
  fontSize: '0.98rem',
  lineHeight: 1.5,
  margin: 0,
  color: '#5a6478',
});

export const JoinButton = styled(Button)({
  flex: '0 0 auto',
  textTransform: 'none',
  borderRadius: 10,
  padding: '11px 24px',
  fontSize: '1rem',
  fontWeight: 700,
  color: '#ffffff',
  background: '#0d4efe',
  boxShadow: '0 4px 14px rgba(13, 78, 254, 0.3)',
  '&:hover': {
    color: '#ffffff',
    background: '#0b43dc',
  },
});

export const BandOffer = styled('p')({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 8,
  flex: '0 0 auto',
  margin: 0,
  padding: '8px 14px',
  borderRadius: 999,
  fontFamily: "'Plus Jakarta Sans', sans-serif",
  fontSize: '0.98rem',
  fontWeight: 800,
  lineHeight: 1.2,
  whiteSpace: 'nowrap',
  color: '#047857',
  background: 'rgba(1, 235, 178, 0.16)',
  border: '1px solid rgba(1, 235, 178, 0.4)',
  '& svg': { fontSize: 20 },
});
